import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const domInjector: Example = {
  id: "dom-injector",
  title: "DOM injection",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Injects a third-party script, a hidden iframe, and a fake overlay",
  explainer:
    "Each injection is a DOM event, and the script and iframe also load (NET resource events). Open the Page preview to see the fake “Verify your card” overlay, outlined as injected.",
  code,
  expect: golden as Example["expect"],
};
